module.exports = __webpack_public_path__ + "static/sport/banner6.e7877b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newldp/banner6.png
// module id = oyRm
// module chunks = 0